module.exports = __webpack_public_path__ + "img/words7.fd191ea3.png";